import {h, Fragment} from "preact"
import { useFacets, useProductFilters } from "@nosto/preact"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import SelectedFilters from "./SelectedFilters"
import Icon from "./elements/Icon"

export const toggleButtonId = "toggle-mobile-sidebar"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
            for={toggleButtonId}
        >
            <Icon name="close" />
        </label>
    )
}

export default function SideBar() {
    const { loading, facets } = useFacets()
    const { filters } = useProductFilters()

    return facets?.length > 0 ? (
        <>
            <input type="checkbox" id={toggleButtonId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for={toggleButtonId}
            />
            <div class="ns-sidebar-wrapper ns-d-none ns-h-100 ns-col-3 ns-col-l-2">
                <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto">
                    <div class="ns-sidebar-header ns-d-flex ns-align-items-baseline ns-justify-content-center">
                        <span class="ns-text-align-center ns-color-black">Filters</span>
                        <ToggleSidebarButton />
                    </div>
                    {filters.length > 0 && 
                        <div class="ns-active-filters">
                            <span>Active filters</span>
                            <SelectedFilters />
                        </div>
                    }
                    <div class="ns-sidebar-menu">
                        <ul class="ns-list-unstyled">
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet key={facet.id} facet={facet} />
                                    case "stats":
                                        return <RangeFacet key={facet.id} facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                    <div class="ns-fixed ns-sidebar-bottom">
                        <button class="ns-sidebar-button" onClick={(e) => e.target.closest(".ns-sidebar-wrapper")?.querySelector(".ns-icon-close")?.click()}>Done</button>
                    </div>
                </div>
            </div>
        </>
    ) : (
        ""
    )
}
